const getDirectoryProfiles = state => {
  return state.directoryProfiles;
};

export default { getDirectoryProfiles };
